// import external dependencies
import 'jquery';
import 'selectize';
import 'bootstrap/dist/js/bootstrap';

// Import everything from autoload


// Import Blocks
import '../../blocks/src/blocks';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import single from './routes/single';
import templateHvac from './routes/templateHvac';
import slick from './routes/slick.min';
import gmap from './gmap';
import smoothScroll from './smoothScroll';
import header from './header'
import headerDesktop from './headerDesktop'

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
    //Single Posts
    single,
    // Slick slider
    slick,
    //Google Map
    gmap,
    //Smooth Scrolling
    smoothScroll,
    //Header
    header,
    //Header on Desktop Only
    headerDesktop,
    //HVAC page
    templateHvac,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js